import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Calendar = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.12 4.49875H17V2.61969C17 2.27986 16.72 2 16.38 2C16.04 2 15.76 2.27986 15.76 2.61969V4.49875H8.25V2.61969C8.25 2.27986 7.97 2 7.63 2C7.29 2 7.01 2.27986 7.01 2.61969V4.49875H3.88C2.85 4.49875 2 5.33833 2 6.37781V20.1209C2 21.1504 2.84 22 3.88 22H20.12C21.15 22 22 21.1604 22 20.1209V6.37781C22 5.34833 21.16 4.49875 20.12 4.49875ZM3.88 5.74813H7V6.9975C7 7.33733 7.28 7.61719 7.62 7.61719C7.96 7.61719 8.24 7.33733 8.24 6.9975V5.74813H15.74V6.9975C15.74 7.33733 16.02 7.61719 16.36 7.61719C16.7 7.61719 16.98 7.33733 16.98 6.9975V5.74813H20.1C20.44 5.74813 20.72 6.02799 20.72 6.36782V9.48626H3.25V6.36782C3.25 6.02799 3.53 5.74813 3.87 5.74813H3.88ZM20.13 20.7406H3.88C3.54 20.7406 3.26 20.4608 3.26 20.1209V10.7456H20.75V20.1209C20.75 20.4608 20.47 20.7406 20.13 20.7406Z" />
  </svg>
)

export default withDefaultStyles(Calendar)
